import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { IconButton, ListItemIcon, ListItemText, MenuItem, Stack } from '@mui/material';
import { DropdownMenu } from 'framework/ui/menu';
import { ActionIconButton } from 'framework/ui/ui-builder';
import type { TimelineItemAction, TimelineMenuAction } from '../types/types';
import TimelineRecordAnchor from './TimelineRecordAnchor';

interface TimelineItemActionsProps {
  timelineId: string | number;
  actions?: TimelineItemAction[];
  menuActions?: TimelineMenuAction[];
  pinAction?: React.ReactNode;
  showAnchor: boolean;
  anchorBasePathname?: string;
}

const TimelineItemActions = ({
  timelineId,
  actions,
  menuActions,
  pinAction,
  showAnchor,
  anchorBasePathname,
}: TimelineItemActionsProps) => (
  <Stack direction="row" spacing={0.5} alignItems="center">
    {actions?.map(action => (
      <ActionIconButton key={action.id} variant="text" color="default" {...action} />
    ))}
    {pinAction}
    {!!menuActions?.length && (
      <DropdownMenu
        popupId={`timeline-actions-${timelineId}`}
        menuPlacement="bottom-end"
        iconButton={
          <IconButton aria-label="More actions" size="small">
            <MoreHorizIcon sx={{ fontSize: 16 }} />
          </IconButton>
        }
      >
        {menuActions.map(action => (
          <MenuItem key={action.id} disabled={action.disabled} onClick={action.onClick}>
            {action.icon && <ListItemIcon>{action.icon}</ListItemIcon>}
            <ListItemText primary={action.label} />
          </MenuItem>
        ))}
      </DropdownMenu>
    )}
    {showAnchor && <TimelineRecordAnchor timelineId={timelineId} basePathname={anchorBasePathname} />}
  </Stack>
);

export default TimelineItemActions;
